export default __webpack_public_path__ + "static/media/pedicure-black.99ae14a9.svg";